/**
 * client-contract-asset.ts
 * Shared Zod contracts for "bienes de uso afectados" to a kernel
 * client_contract (add-kernel-client-enrichment, design.md §5).
 *
 * clientContractId comes from the URL path, never the body — mirrors
 * @suite/contracts-rrhh's ClientContractAssignmentCreateSchema.
 */
import { z } from 'zod';

export const ClientContractAssetCreateSchema = z
  .object({
    assetId: z.string().uuid(),
    startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'startDate must be YYYY-MM-DD.'),
    endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'endDate must be YYYY-MM-DD.').optional(),
  })
  .refine((body) => body.endDate === undefined || body.endDate >= body.startDate, {
    message: 'endDate must not be before startDate.',
    path: ['endDate'],
  });
export type ClientContractAssetCreate = z.infer<typeof ClientContractAssetCreateSchema>;

export const ClientContractAssetResponseSchema = z.object({
  id: z.string().uuid(),
  clientContractId: z.string().uuid(),
  assetId: z.string().uuid(),
  startDate: z.string(),
  endDate: z.string().nullable(),
  createdAt: z.string().datetime(),
});
export type ClientContractAssetResponse = z.infer<typeof ClientContractAssetResponseSchema>;
